import React, {useContext} from "react";
import {BlockNavigation} from "../../../layout/block";
import './DetailedProjectNavigation.scoped.scss';
import {CustomLink} from "../../../common";
import {RouteDictionary} from "../../../../utils";
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import {matchPath, useLocation} from "react-router-dom";
import {hasCollateralInfo, isSocialProject} from "../../../../utils/pages";

const DetailedProjectNavigation = () => {
  const {project} = useContext(DetailedProjectContext);
  const {pathname} = useLocation();
  const isSocial = isSocialProject(project);
  const showCollateralInfo = !isSocial && hasCollateralInfo(project);
  const navItems = [
    {
      label: "Информация о проекте",
      route: RouteDictionary.PROJECT_ECONOMIC_ANALYSIS,
      event: "economical-analysis-project-card",
      patterns: ["dashboard/project/:uuid", "dashboard/project/:uuid/economic"],
    },
    {
      label: "Информация о заемщике",
      route: RouteDictionary.PROJECT_LEGAL_ANALYSIS,
      event: "legal-analysis-project-card",
      patterns: ["dashboard/project/:uuid/legal"],
    },
    ...(showCollateralInfo ? [{
      label: "Информация об обеспечении",
      route: RouteDictionary.PROJECT_STRATEGY,
      event: "collection-strategy-project-card",
      patterns: ["dashboard/project/:uuid/strategy"],
    }] : []),
    {
      label: "Документы",
      route: RouteDictionary.PROJECT_DOCUMENTS,
      event: "collection-documents-project-card",
      patterns: ["dashboard/project/:uuid/documents"],
    },
    {
      label: isSocial ? "График выплат" : "График погашения",
      route: RouteDictionary.PAYMENT_SCHEDULE,
      event: "collection-documents-project-card",
      patterns: ["dashboard/project/:uuid/payment-schedule"],
    },
    {
      label: "События",
      route: RouteDictionary.PROJECT_STAGES,
      event: "collection-events-project-card",
      patterns: ["dashboard/project/:uuid/stages"],
    },
  ];

  return (
    <BlockNavigation className="detailed-project-navigation">
      {navItems.map(({label, route, event, patterns}) => {
        const isActive = patterns.some((pattern) => matchPath(pattern, pathname));
        const itemClass = isActive
          ? "detailed-project-navigation__element-active"
          : "detailed-project-navigation__element";

        return (
          <li key={label} className={itemClass}>
            <CustomLink
              to={route}
              params={{uuid: project.uuid}}
              className="detailed-project-navigation__link"
              explicitActive={isActive}
            >
              {label}
            </CustomLink>
          </li>
        );
      })}
    </BlockNavigation>
  );
};


export default DetailedProjectNavigation;